/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {LOCALE_ID, NgModule} from '@angular/core';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import localeEs from '@angular/common/locales/es-AR';
registerLocaleData(localeEs);
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
} from '@nebular/theme';
import {PersonaService} from "./services/persona.service";
import {CompradorService} from "./services/comprador.service";
import {ProveedorService} from "./services/proveedor.service";
import {SecModule} from "./sec/sec.module";
import {CompradorLugaresService} from "./services/comprador-lugares.service";
import {registerLocaleData} from "@angular/common";
import {CalendarioService} from "./services/calendario.service";
import {MotivoService} from "./services/motivo.service";
import {FechasDiasExcepService} from "./services/fechas-dias-excep.service";
import {ProveedorRubroService} from "./services/proveedor-rubro.service";
import {RubroService} from "./services/rubro.service";
import {CompradorCapacidadRecepcionService} from "./services/comprador-capacidad-recepcion.service";
import {ProveedorVehiculoService} from "./services/proveedor-vehiculo.service";



@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
      SecModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    }),
    CoreModule.forRoot(),
    ThemeModule.forRoot(),
  ],
  bootstrap: [AppComponent],
  providers: [PersonaService, CompradorService, ProveedorService,
    CompradorLugaresService,CalendarioService,MotivoService,FechasDiasExcepService,
      ProveedorRubroService,RubroService,CompradorCapacidadRecepcionService, ProveedorVehiculoService,
    { provide: LOCALE_ID, useValue: 'es-AR' },
  ],
})
export class AppModule {
}
